/**
 * Featured Cars — theater video stage, shoppable mod list, XO Gallery app hook
 * Root: [data-sm-featured-car]
 * Docs: FEATURED-CARS.md
 */
(function () {
  'use strict';

  var ROOT_SEL = '[data-sm-featured-car]';
  var REDUCE_MQ = '(prefers-reduced-motion: reduce)';
  var PREVIEW_DELAY = 420;
  var GRID_PAGE_DESKTOP = 9;
  var GRID_PAGE_MOBILE = 6;
  var MOBILE_MQ = '(max-width: 767px)';
  var REVIEWS_PER_PAGE = 10;
  var OTHER_CATEGORY = 'Other';
  var SHOWROOM_CATEGORIES = [
    'Brakes', 'Cooling', 'Drivetrain', 'Engine', 'Engine Management', 'Exhaust',
    'Exterior', 'Forced Induction', 'Fuel', 'Intake', 'Interior', 'Merchandise',
    'Suspension', 'Wheels'
  ];
  var STAR_SVG = '<svg viewBox="0 0 20 20" aria-hidden="true"><path fill="currentColor" d="M10 1.6 12.7 7l6 .9-4.4 4.2 1 5.9L10 15.2 4.7 18l1-5.9L1.3 7.9 7.3 7 10 1.6Z"/></svg>';

  function qs(root, sel) {
    return root ? root.querySelector(sel) : null;
  }

  function qsa(root, sel) {
    return root ? Array.prototype.slice.call(root.querySelectorAll(sel)) : [];
  }

  function absUrl(value) {
    var url = String(value || '').trim();
    if (!url) return '';
    if (url.indexOf('//') === 0) return 'https:' + url;
    return url;
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function uniqueSorted(values) {
    var seen = {};
    var out = [];
    (values || []).forEach(function (value) {
      var key = String(value || '').trim();
      if (!key || seen[key]) return;
      seen[key] = true;
      out.push(key);
    });
    out.sort(function (a, b) {
      return a.localeCompare(b);
    });
    return out;
  }

  function reviewCount(product) {
    return Number(product && product.ratingCount ? product.ratingCount : 0);
  }

  function reviewRating(product) {
    return Number(product && product.rating ? product.rating : 0);
  }

  function starsHtml(rating) {
    var value = Number(rating) || 0;
    var html = '<span class="sm-fc-stars" aria-hidden="true">';
    var i;
    for (i = 1; i <= 5; i += 1) {
      var fill = Math.max(0, Math.min(1, value - (i - 1)));
      html +=
        '<span class="sm-fc-star">' +
          '<span class="sm-fc-star__base">' + STAR_SVG + '</span>' +
          '<span class="sm-fc-star__fill" style="width:' + (fill * 100) + '%">' + STAR_SVG + '</span>' +
        '</span>';
    }
    return html + '</span>';
  }

  function formatCount(value) {
    return String(Number(value) || 0);
  }

  function orderedCategories(values) {
    var seen = {};
    var extras = [];
    var ordered = [];
    (values || []).forEach(function (value) {
      var key = String(value || '').trim();
      if (!key || seen[key] || key === OTHER_CATEGORY) return;
      seen[key] = true;
      extras.push(key);
    });
    SHOWROOM_CATEGORIES.forEach(function (name) {
      if (!seen[name]) return;
      ordered.push(name);
      seen[name] = false;
    });
    extras.sort(function (a, b) { return a.localeCompare(b); }).forEach(function (name) {
      if (seen[name]) ordered.push(name);
    });
    if (values && values.indexOf(OTHER_CATEGORY) !== -1) ordered.push(OTHER_CATEGORY);
    return ordered;
  }

  function textOf(node) {
    return node ? String(node.textContent || '').replace(/\s+/g, ' ').trim() : '';
  }

  function cleanDescription(html) {
    var raw = String(html || '').trim();
    if (!raw) return '';
    var wrap = document.createElement('div');
    wrap.innerHTML = raw;
    var overview = null;
    var headings = wrap.querySelectorAll('h1, h2, h3, h4, h5, h6, p, strong');
    var i;
    for (i = 0; i < headings.length; i += 1) {
      var text = String(headings[i].textContent || '').replace(/\s+/g, ' ').trim();
      if (/^overview$/i.test(text)) {
        overview = headings[i];
        break;
      }
    }
    if (!overview) return raw;
    var keep = [];
    var node = overview.nextSibling;
    while (node) {
      keep.push(node);
      node = node.nextSibling;
    }
    if (!keep.length && overview.parentNode && overview.parentNode !== wrap) {
      node = overview.nextSibling;
      while (node) {
        keep.push(node);
        node = node.nextSibling;
      }
      node = overview.parentNode.nextSibling;
      while (node) {
        keep.push(node);
        node = node.nextSibling;
      }
    }
    var out = document.createElement('div');
    keep.forEach(function (el) {
      out.appendChild(el.cloneNode(true));
    });
    return out.innerHTML.trim() || raw;
  }

  function parseWidgetReviews(widgetHtml) {
    var html = String(widgetHtml || '');
    if (!html) return [];
    var wrap = document.createElement('div');
    wrap.innerHTML = html;
    var nodes = wrap.querySelectorAll('.jdgm-rev');
    var out = [];
    var i;
    for (i = 0; i < nodes.length; i += 1) {
      var node = nodes[i];
      if (!node || node.classList.contains('jdgm-rev-widg')) continue;
      var ratingEl = node.querySelector('.jdgm-rev__rating');
      var timeEl = node.querySelector('time');
      var photos = [];
      var seen = {};
      qsa(node, '.jdgm-rev__pic-img, .jdgm-rev__pic-link').forEach(function (el) {
        var src = el.getAttribute('data-src') || el.getAttribute('data-mfp-src') || el.getAttribute('src') || el.getAttribute('href') || '';
        src = absUrl(src);
        if (!src || seen[src]) return;
        seen[src] = true;
        photos.push(src);
      });
      out.push({
        id: node.getAttribute('data-review-id') || '',
        rating: Number(ratingEl && ratingEl.getAttribute('data-score') || 0),
        name: textOf(node.querySelector('.jdgm-rev__author')) || 'Verified buyer',
        title: textOf(node.querySelector('.jdgm-rev__title')),
        body: textOf(node.querySelector('.jdgm-rev__body')),
        created: (timeEl && (timeEl.getAttribute('datetime') || timeEl.getAttribute('data-content'))) || '',
        photos: photos,
        reply: textOf(node.querySelector('.jdgm-rev__reply-content'))
      });
    }
    return out;
  }

  function formatReviewDate(value) {
    if (!value) return '';
    var date = new Date(value);
    if (isNaN(date.getTime())) return '';
    return date.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
  }

  function parseConfig() {
    var el = document.getElementById('sm-fc-config');
    if (!el) return {};
    try {
      return JSON.parse(el.textContent || '{}') || {};
    } catch (err) {
      return {};
    }
  }

  function initRoot(root) {
    if (!root || root.dataset.smFcReady === '1') return;
    root.dataset.smFcReady = '1';
    document.documentElement.classList.add('sm-featured-car-page');
    initVideo(root);
    initShop(root);
  }

  function gridPageSize() {
    return window.matchMedia(MOBILE_MQ).matches ? GRID_PAGE_MOBILE : GRID_PAGE_DESKTOP;
  }

  function initVideo(root) {
    var cards = qsa(root, '[data-sm-fc-clip-card]').filter(function (card) {
      return !card.hasAttribute('data-sm-fc-clone');
    });
    if (!cards.length) return;

    var ambient = qs(root, '[data-sm-fc-ambient]');
    var dots = qsa(root, '[data-sm-fc-dot]');
    var prevBtn = qs(root, '[data-sm-fc-prev]');
    var nextBtn = qs(root, '[data-sm-fc-next]');
    var dialog = qs(root, '[data-sm-fc-dialog]');
    var player = qs(root, '[data-sm-fc-player]');
    var closeBtn = qs(root, '[data-sm-fc-dialog-close]');
    var track = qs(root, '[data-sm-fc-track]');

    var previewEnabled = root.getAttribute('data-sm-fc-preview') === '1';
    var reduceMotion = window.matchMedia(REDUCE_MQ).matches;
    var desktopMq = window.matchMedia('(min-width: 900px)');
    var activeIndex = 0;
    var previewTimer = null;
    var touchStartX = null;
    var SIDE_SLOTS = [-2, -1, 1, 2];

    function clampIndex(index) {
      if (index < 0) return cards.length - 1;
      if (index >= cards.length) return 0;
      return index;
    }

    function modIndex(index) {
      var n = cards.length;
      return ((index % n) + n) % n;
    }

    function wrappedOffset(i, active, n) {
      var offset = i - active;
      offset = ((offset % n) + n) % n;
      if (offset > n / 2) offset -= n;
      return offset;
    }

    function clearClones() {
      if (!track) return;
      qsa(track, '[data-sm-fc-clone]').forEach(function (clone) {
        if (clone.parentNode) clone.parentNode.removeChild(clone);
      });
    }

    function clearPreviews() {
      cards.forEach(function (card) {
        var mount = qs(card, '[data-sm-fc-card-preview]');
        if (mount) mount.innerHTML = '';
        card.classList.remove('has-preview');
      });
    }

    function loadMutedPreview(card) {
      if (!previewEnabled || reduceMotion) return;
      var src = absUrl(card.getAttribute('data-src') || '');
      var mount = qs(card, '[data-sm-fc-card-preview]');
      if (!src || !mount) return;

      var video = document.createElement('video');
      video.className = 'sm-support-theater-card__iframe';
      video.muted = true;
      video.loop = true;
      video.playsInline = true;
      video.setAttribute('playsinline', '');
      video.setAttribute('muted', '');
      video.preload = 'metadata';
      video.setAttribute('aria-hidden', 'true');
      video.tabIndex = -1;
      video.src = src;
      mount.appendChild(video);
      card.classList.add('has-preview');
      var playPromise = video.play();
      if (playPromise && playPromise.catch) playPromise.catch(function () {});
    }

    function schedulePreview(card) {
      window.clearTimeout(previewTimer);
      clearPreviews();
      if (!previewEnabled || reduceMotion) return;
      previewTimer = window.setTimeout(function () {
        loadMutedPreview(card);
      }, PREVIEW_DELAY);
    }

    function updateAmbient(card) {
      if (!ambient) return;
      var thumb = absUrl(card.getAttribute('data-thumb') || '');
      if (thumb) {
        ambient.style.backgroundImage = 'url("' + thumb.replace(/"/g, '\\"') + '")';
        ambient.classList.add('is-visible');
      } else {
        ambient.style.backgroundImage = '';
        ambient.classList.remove('is-visible');
      }
    }

    function fillDesktopSides() {
      clearClones();
      if (!track || !desktopMq.matches || cards.length < 2) return;

      var n = cards.length;
      var used = {};

      cards.forEach(function (card, i) {
        var offset = wrappedOffset(i, activeIndex, n);
        used[String(offset)] = true;
        card.setAttribute('data-offset', String(offset));
      });

      SIDE_SLOTS.forEach(function (slot) {
        if (used[String(slot)]) return;

        var sourceIndex = modIndex(activeIndex + slot);
        var source = cards[sourceIndex];
        if (!source) return;

        var clone = source.cloneNode(true);
        clone.classList.remove('is-active', 'has-preview');
        clone.setAttribute('data-sm-fc-clone', '1');
        clone.setAttribute('data-offset', String(slot));
        clone.setAttribute('data-index', String(sourceIndex));
        clone.removeAttribute('id');

        var preview = qs(clone, '[data-sm-fc-card-preview]');
        if (preview) preview.innerHTML = '';

        var hit = qs(clone, '[data-sm-fc-select]');
        if (hit) hit.setAttribute('aria-pressed', 'false');

        track.appendChild(clone);
        used[String(slot)] = true;
      });
    }

    function setActive(index, options) {
      options = options || {};
      activeIndex = clampIndex(index);
      var activeCard = cards[activeIndex];
      if (!activeCard) return;

      var n = cards.length;

      cards.forEach(function (card, i) {
        var offset = desktopMq.matches
          ? wrappedOffset(i, activeIndex, n)
          : i - activeIndex;
        card.setAttribute('data-offset', String(offset));
        card.classList.toggle('is-active', i === activeIndex);
        var hit = qs(card, '[data-sm-fc-select]');
        if (hit) hit.setAttribute('aria-pressed', i === activeIndex ? 'true' : 'false');
      });

      fillDesktopSides();

      dots.forEach(function (dot, i) {
        var on = i === activeIndex;
        dot.classList.toggle('is-active', on);
        dot.setAttribute('aria-current', on ? 'true' : 'false');
      });

      updateAmbient(activeCard);

      if (options.preview !== false) schedulePreview(activeCard);

      if (options.scrollIntoView && track && !desktopMq.matches) {
        activeCard.scrollIntoView({
          behavior: reduceMotion ? 'auto' : 'smooth',
          inline: 'center',
          block: 'nearest'
        });
      }
    }

    function openPlayer(card) {
      if (!dialog || !player) return;
      var src = absUrl(card.getAttribute('data-src') || '');
      if (!src) return;

      clearPreviews();
      window.clearTimeout(previewTimer);

      var poster = absUrl(card.getAttribute('data-thumb') || '');
      var title = card.getAttribute('data-title') || 'Build clip';
      player.innerHTML =
        '<video class="sm-fc-dialog-video" controls playsinline autoplay' +
        (poster ? ' poster="' + poster.replace(/"/g, '') + '"' : '') +
        ' src="' + src.replace(/"/g, '') + '"' +
        ' title="' + escapeHtml(title) + '"></video>';

      root.classList.add('is-player-open');
      document.documentElement.classList.add('sm-fc-player-open');

      if (typeof dialog.showModal === 'function') {
        dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
      }

      if (closeBtn && typeof closeBtn.focus === 'function') closeBtn.focus();
    }

    function closePlayer() {
      if (!dialog) return;
      if (typeof dialog.close === 'function' && dialog.open) {
        dialog.close();
      } else {
        dialog.removeAttribute('open');
      }
      root.classList.remove('is-player-open');
      document.documentElement.classList.remove('sm-fc-player-open');
      if (player) player.innerHTML = '';
      schedulePreview(cards[activeIndex]);
    }

    root.addEventListener('click', function (event) {
      var selectBtn = event.target.closest('[data-sm-fc-select]');
      if (selectBtn && root.contains(selectBtn)) {
        var card = selectBtn.closest('[data-sm-fc-clip-card]');
        if (!card) return;
        var index = Number(card.getAttribute('data-index') || 0);
        if (card.classList.contains('is-active')) {
          openPlayer(card);
          return;
        }
        setActive(index, { scrollIntoView: true });
        return;
      }

      var dot = event.target.closest('[data-sm-fc-dot]');
      if (dot && root.contains(dot)) {
        setActive(Number(dot.getAttribute('data-index') || 0), { scrollIntoView: true });
        return;
      }

      if (event.target.closest('[data-sm-fc-prev]')) {
        setActive(activeIndex - 1, { scrollIntoView: true });
        return;
      }

      if (event.target.closest('[data-sm-fc-next]')) {
        setActive(activeIndex + 1, { scrollIntoView: true });
        return;
      }

      if (event.target.closest('[data-sm-fc-dialog-close]')) {
        closePlayer();
      }
    });

    if (dialog) {
      dialog.addEventListener('click', function (event) {
        if (event.target === dialog) closePlayer();
      });
      dialog.addEventListener('cancel', function (event) {
        event.preventDefault();
        closePlayer();
      });
      dialog.addEventListener('close', function () {
        root.classList.remove('is-player-open');
        document.documentElement.classList.remove('sm-fc-player-open');
        if (player) player.innerHTML = '';
      });
    }

    document.addEventListener('keydown', function (event) {
      if (!root.contains(document.activeElement) && !root.classList.contains('is-player-open')) {
        return;
      }
      if (root.classList.contains('is-player-open')) {
        if (event.key === 'Escape') closePlayer();
        return;
      }
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        setActive(activeIndex - 1, { scrollIntoView: true });
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        setActive(activeIndex + 1, { scrollIntoView: true });
      }
    });

    if (track) {
      track.addEventListener('touchstart', function (event) {
        touchStartX = event.changedTouches[0].clientX;
      }, { passive: true });
      track.addEventListener('touchend', function (event) {
        if (touchStartX == null) return;
        var delta = event.changedTouches[0].clientX - touchStartX;
        touchStartX = null;
        if (Math.abs(delta) < 40) return;
        if (delta > 0) setActive(activeIndex - 1, { scrollIntoView: true });
        else setActive(activeIndex + 1, { scrollIntoView: true });
      }, { passive: true });
    }

    if (prevBtn) prevBtn.disabled = cards.length < 2;
    if (nextBtn) nextBtn.disabled = cards.length < 2;

    function onDesktopChange() {
      setActive(activeIndex, {
        preview: false,
        scrollIntoView: !desktopMq.matches
      });
    }

    if (typeof desktopMq.addEventListener === 'function') {
      desktopMq.addEventListener('change', onDesktopChange);
    } else if (typeof desktopMq.addListener === 'function') {
      desktopMq.addListener(onDesktopChange);
    }

    setActive(0, {
      preview: true,
      scrollIntoView: !desktopMq.matches
    });
  }

  function initShop(root) {
    var shop = qs(root, '[data-sm-fc-shop]');
    if (!shop) return;

    var config = parseConfig();
    var catsEl = qs(shop, '[data-sm-fc-cats]');
    var catSelect = qs(shop, '[data-sm-fc-cat-select]');
    var gridEl = qs(shop, '[data-sm-fc-grid]');
    var emptyEl = qs(shop, '[data-sm-fc-empty]');
    var loadEl = qs(shop, '[data-sm-fc-load]');
    var moreWrap = qs(shop, '[data-sm-fc-more]');
    var moreBtn = qs(shop, '[data-sm-fc-load-more]');
    var panelLabel = qs(shop, '[data-sm-fc-panel-label]');
    var panelTitle = qs(shop, '[data-sm-fc-panel-title]');
    var modal = qs(root, '[data-sm-fc-modal]');
    var modalReviewsEl = modal ? qs(modal, '[data-sm-fc-modal-reviews]') : null;
    var modalDescEl = modal ? qs(modal, '[data-sm-fc-modal-desc]') : null;
    var modalStarsEl = modal ? qs(modal, '[data-sm-fc-modal-stars]') : null;

    var products = [];
    var state = {
      category: '',
      visibleCount: gridPageSize()
    };
    var modalProduct = null;
    var modalView = 'reviews';
    var reviewsPage = 0;
    var reviewsShown = 0;
    var reviewsTotal = 0;
    var reviewsLoading = false;
    var reviewsSeen = {};
    var reviewsRequestId = 0;

    function setLoad(message) {
      if (!loadEl) return;
      if (!message) {
        loadEl.hidden = true;
        loadEl.textContent = '';
        return;
      }
      loadEl.hidden = false;
      loadEl.textContent = message;
    }

    function productCategories(product) {
      var cats = product && product.categories;
      if (!Array.isArray(cats)) return [];
      return cats.map(function (cat) { return String(cat || '').trim(); }).filter(Boolean);
    }

    function catalogCategories() {
      var found = [];
      var hasOther = false;
      products.forEach(function (product) {
        var cats = productCategories(product);
        if (!cats.length) hasOther = true;
        found = found.concat(cats);
      });
      if (hasOther) found.push(OTHER_CATEGORY);
      return orderedCategories(found);
    }

    function filteredProducts() {
      return products.filter(function (product) {
        var cats = productCategories(product);
        if (!state.category) return true;
        if (state.category === OTHER_CATEGORY) return cats.length === 0;
        return cats.indexOf(state.category) !== -1;
      });
    }

    function categoryLabel() {
      return state.category || 'All mods';
    }

    function updatePanelCopy() {
      var label = categoryLabel();
      if (panelLabel) panelLabel.textContent = label;
      if (panelTitle) {
        panelTitle.textContent = state.category ? 'Shop ' + label : 'All mods on this build';
      }
    }

    function renderNav() {
      var cats = catalogCategories();
      if (catsEl) {
        var html = '<button type="button" class="sm-fc-nav__item' + (state.category === '' ? ' is-active' : '') + '" data-sm-fc-filter="category" data-value="" aria-pressed="' + (state.category === '' ? 'true' : 'false') + '"><span class="sm-fc-nav__label">All mods</span></button>';
        cats.forEach(function (value) {
          var on = state.category === value;
          html += '<button type="button" class="sm-fc-nav__item' + (on ? ' is-active' : '') + '" data-sm-fc-filter="category" data-value="' + escapeHtml(value) + '" aria-pressed="' + (on ? 'true' : 'false') + '"><span class="sm-fc-nav__label">' + escapeHtml(value) + '</span></button>';
        });
        catsEl.innerHTML = html;
      }
      if (catSelect) {
        var opts = '<option value="">All mods</option>';
        cats.forEach(function (value) {
          opts += '<option value="' + escapeHtml(value) + '"' + (state.category === value ? ' selected' : '') + '>' + escapeHtml(value) + '</option>';
        });
        catSelect.innerHTML = opts;
        catSelect.value = state.category;
      }
    }

    function formatPrice(product) {
      var html = escapeHtml(product.price || '');
      if (product.compareAt && product.compareAtCents && product.priceCents && product.compareAtCents > product.priceCents) {
        html += '<span class="sm-fc-card__compare">' + escapeHtml(product.compareAt) + '</span>';
      }
      return html;
    }

    function ratingLine(product) {
      var count = reviewCount(product);
      var rating = reviewRating(product);
      return (
        '<span class="sm-fc-card__rating">' +
          starsHtml(rating) +
          '<span class="sm-fc-card__count">' +
            (rating ? rating.toFixed(1) + ' · ' : '') +
            formatCount(count) + (count === 1 ? ' review' : ' reviews') +
          '</span>' +
        '</span>'
      );
    }

    function renderCards(list, append) {
      if (!gridEl) return;
      var start = append ? gridEl.children.length : 0;
      var slice = list.slice(start, state.visibleCount);
      var html = slice.map(function (product) {
        var image = absUrl(product.image);
        var cats = productCategories(product);
        var catLabel = state.category && state.category !== OTHER_CATEGORY
          ? state.category
          : (cats[0] || product.type || '');
        var media = image
          ? '<span class="sm-fc-card__media" style="background-image:url(\'' + escapeHtml(image) + '\')"><img src="' + escapeHtml(image) + '" alt="">'
          : '<span class="sm-fc-card__media"><span class="sm-fc-card__ph" aria-hidden="true"></span>';
        var badge = product.available ? '' : '<span class="sm-fc-card__badge">Sold out</span>';
        return (
          '<article class="sm-fc-card" data-sm-fc-card="' + escapeHtml(String(product.id)) + '">' +
            media + badge + '</span>' +
            '<div class="sm-fc-card__copy">' +
              (catLabel ? '<span class="sm-fc-card__cat">' + escapeHtml(catLabel) + '</span>' : '') +
              '<h3 class="sm-fc-card__title">' + escapeHtml(product.title) + '</h3>' +
              (product.vendor ? '<span class="sm-fc-card__vendor">' + escapeHtml(product.vendor) + (product.type ? ' · ' + escapeHtml(product.type) : '') + '</span>' : '') +
              ratingLine(product) +
              '<div class="sm-fc-card__price">' + formatPrice(product) + '</div>' +
              '<div class="sm-fc-card__actions">' +
                '<button type="button" class="sm-support-btn sm-support-btn--primary" data-sm-fc-atc="' + escapeHtml(String(product.id)) + '"' + (product.available ? '' : ' disabled') + '>' +
                  (product.available ? 'Add to cart' : 'Sold out') +
                '</button>' +
                '<button type="button" class="sm-support-btn sm-support-btn--ghost" data-sm-fc-details="' + escapeHtml(String(product.id)) + '">Details</button>' +
              '</div>' +
            '</div>' +
          '</article>'
        );
      }).join('');

      if (append) gridEl.insertAdjacentHTML('beforeend', html);
      else gridEl.innerHTML = html;

      if (moreWrap) moreWrap.hidden = list.length <= state.visibleCount;
      if (emptyEl && products.length) emptyEl.hidden = list.length > 0;
    }

    function renderShop() {
      renderNav();
      updatePanelCopy();
      renderCards(filteredProducts(), false);
    }

    function productById(id) {
      var key = String(id);
      for (var i = 0; i < products.length; i += 1) {
        if (String(products[i].id) === key) return products[i];
      }
      return null;
    }

    function openCartDrawer() {
      try {
        if (typeof window.SLIDECART_UPDATE === 'function') window.SLIDECART_UPDATE();
        if (typeof window.SLIDECART_OPEN === 'function') {
          window.setTimeout(function () { window.SLIDECART_OPEN(); }, 250);
          return true;
        }
      } catch (err) { /* optional */ }
      return false;
    }

    function addToCart(variantId, btn) {
      if (!variantId || !btn || btn.disabled) return;
      var original = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Cart add failed');
          return res.json();
        })
        .then(function () {
          btn.textContent = 'Added';
          document.dispatchEvent(new CustomEvent('cart:updated'));
          document.dispatchEvent(new CustomEvent('theme:cart:change'));
          openCartDrawer();
          window.setTimeout(function () {
            btn.textContent = original || 'Add to cart';
            btn.disabled = false;
          }, 1600);
        })
        .catch(function () {
          btn.textContent = 'Try again';
          btn.disabled = false;
          window.setTimeout(function () {
            btn.textContent = original || 'Add to cart';
          }, 1600);
        });
    }

    function firstAvailableVariant(product) {
      if (!product) return null;
      if (product.variants && product.variants.length) {
        for (var i = 0; i < product.variants.length; i += 1) {
          if (product.variants[i].available) return product.variants[i];
        }
        return product.variants[0];
      }
      return { id: product.variantId, available: product.available };
    }

    function shopDomain() {
      var settings = window.jdgmSettings || {};
      return settings.shop_domain || config.shopDomain || '';
    }

    function widgetPageUrl(productId, page) {
      var domain = shopDomain();
      if (!domain || !productId) return '';
      return 'https://api.judge.me/reviews/reviews_for_widget'
        + '?url=' + encodeURIComponent(domain)
        + '&shop_domain=' + encodeURIComponent(domain)
        + '&platform=shopify'
        + '&page=' + (page || 1)
        + '&per_page=' + REVIEWS_PER_PAGE
        + '&product_id=' + encodeURIComponent(productId);
    }

    function uniqueReviews(list) {
      var out = [];
      (list || []).forEach(function (review) {
        var key = String(review && review.id ? review.id : '') ||
          [review.title, review.body, review.created].join('|');
        if (!key || reviewsSeen[key]) return;
        reviewsSeen[key] = true;
        out.push(review);
      });
      return out;
    }

    function renderReviewCards(reviews) {
      return reviews.map(function (review) {
        var created = formatReviewDate(review.created);
        return (
          '<article class="sm-fc-review">' +
            '<div class="sm-fc-review__head">' +
              starsHtml(review.rating) +
              '<span class="sm-fc-review__name">' + escapeHtml(review.name || 'Verified buyer') + '</span>' +
              (created ? '<span class="sm-fc-review__date">' + escapeHtml(created) + '</span>' : '') +
            '</div>' +
            (review.title ? '<h3 class="sm-fc-review__title">' + escapeHtml(review.title) + '</h3>' : '') +
            (review.body ? '<p class="sm-fc-review__body">' + escapeHtml(review.body) + '</p>' : '') +
            (review.photos && review.photos.length
              ? '<div class="sm-fc-review__photos">' + review.photos.map(function (src) {
                return '<img src="' + escapeHtml(src) + '" alt="">';
              }).join('') + '</div>'
              : '') +
            (review.reply ? '<div class="sm-fc-review__reply">' + escapeHtml(review.reply) + '</div>' : '') +
          '</article>'
        );
      }).join('');
    }

    function reviewsMoreHtml() {
      if (reviewsShown >= reviewsTotal) return '';
      var left = Math.max(0, reviewsTotal - reviewsShown);
      return (
        '<div class="sm-fc-reviews-more">' +
          '<button type="button" class="sm-support-btn sm-support-btn--primary" data-sm-fc-reviews-more>' +
            escapeHtml(left ? 'Load more reviews (' + formatCount(left) + ' left)' : 'Load more reviews') +
          '</button>' +
        '</div>'
      );
    }

    function hideReviewsMore() {
      if (!modalReviewsEl) return;
      var more = qs(modalReviewsEl, '.sm-fc-reviews-more');
      if (more) more.remove();
    }

    function setModalReviewsHtml(html) {
      if (modalReviewsEl) modalReviewsEl.innerHTML = html;
    }

    function paintReviews(list, append) {
      var fresh = uniqueReviews(list);
      reviewsShown += fresh.length;
      if (append && !fresh.length) reviewsTotal = reviewsShown;
      var cards = renderReviewCards(fresh);
      if (append && modalReviewsEl) {
        hideReviewsMore();
        if (cards) modalReviewsEl.insertAdjacentHTML('beforeend', cards);
        modalReviewsEl.insertAdjacentHTML('beforeend', reviewsMoreHtml());
        return;
      }
      if (!cards && !reviewsShown) {
        setModalReviewsHtml('<p class="sm-fc-modal__reviews-empty">No reviews loaded yet.</p>' + reviewsMoreHtml());
        return;
      }
      setModalReviewsHtml(cards + reviewsMoreHtml());
    }

    function applyReviewPage(payload, page, append) {
      if (payload && payload.total_count != null && payload.total_count !== '') {
        var total = Number(payload.total_count);
        if (!isNaN(total) && total >= 0) reviewsTotal = total;
      }
      reviewsPage = Number(payload && payload.page ? payload.page : page);
      var parsed = parseWidgetReviews(payload && payload.html);
      if (!append) {
        reviewsSeen = {};
        reviewsShown = 0;
      }
      if (!parsed.length) {
        reviewsTotal = reviewsShown;
        if (!append && !reviewsShown) {
          setModalReviewsHtml('<p class="sm-fc-modal__reviews-empty">No reviews loaded yet.</p>');
          return;
        }
        hideReviewsMore();
        return;
      }
      paintReviews(parsed, append);
      if (reviewsShown >= reviewsTotal) hideReviewsMore();
    }

    function loadReviewPage(page, append) {
      if (!modalProduct || reviewsLoading) return;
      if (append && reviewsTotal > 0 && reviewsShown >= reviewsTotal) return;
      var url = widgetPageUrl(modalProduct.id, page);
      if (!url) {
        if (!append) setModalReviewsHtml('<p class="sm-fc-modal__reviews-empty">No reviews loaded yet.</p>');
        return;
      }
      reviewsLoading = true;
      var requestId = ++reviewsRequestId;
      var btn = modalReviewsEl ? qs(modalReviewsEl, '[data-sm-fc-reviews-more]') : null;
      if (btn) {
        btn.disabled = true;
        btn.textContent = 'Loading…';
      }
      fetch(url, { credentials: 'omit', headers: { Accept: 'application/json' } })
        .then(function (res) {
          if (!res.ok) throw new Error('reviews page');
          return res.json();
        })
        .then(function (payload) {
          if (requestId !== reviewsRequestId) return;
          applyReviewPage(payload, page, append);
        })
        .catch(function () {
          if (requestId !== reviewsRequestId) return;
          if (!append) setModalReviewsHtml('<p class="sm-fc-modal__reviews-empty">No reviews loaded yet.</p>');
          else hideReviewsMore();
        })
        .then(function () {
          if (requestId === reviewsRequestId) reviewsLoading = false;
        });
    }

    function setModalView(view) {
      modalView = view === 'details' ? 'details' : 'reviews';
      if (!modal) return;
      modal.setAttribute('data-sm-fc-view', modalView);
      qsa(modal, '[data-sm-fc-modal-view]').forEach(function (btn) {
        var on = btn.getAttribute('data-sm-fc-modal-view') === modalView;
        btn.classList.toggle('is-active', on);
        btn.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      qsa(modal, '[data-sm-fc-modal-pane]').forEach(function (pane) {
        pane.hidden = pane.getAttribute('data-sm-fc-modal-pane') !== modalView;
      });
    }

    function renderThumbs(imageEl, thumbsEl, images) {
      if (imageEl) {
        imageEl.src = images[0] || '';
        imageEl.alt = (modalProduct && modalProduct.title) || '';
      }
      if (!thumbsEl) return;
      thumbsEl.hidden = images.length < 2;
      thumbsEl.innerHTML = images.map(function (src, i) {
        return '<button type="button" class="sm-fc-modal__thumb' + (i === 0 ? ' is-active' : '') + '" data-src="' + escapeHtml(src) + '"><img src="' + escapeHtml(src) + '" alt=""></button>';
      }).join('');
    }

    function openModal(product) {
      if (!modal || !product) return;
      modalProduct = product;
      reviewsRequestId += 1;
      reviewsLoading = false;
      reviewsSeen = {};
      reviewsShown = 0;
      reviewsTotal = reviewCount(product);
      reviewsPage = 1;

      var imageEl = qs(modal, '[data-sm-fc-modal-image]');
      var thumbsEl = qs(modal, '[data-sm-fc-modal-thumbs]');
      var vendorElM = qs(modal, '[data-sm-fc-modal-vendor]');
      var titleEl = qs(modal, '[data-sm-fc-modal-title]');
      var priceEl = qs(modal, '[data-sm-fc-modal-price]');
      var variantEl = qs(modal, '[data-sm-fc-modal-variant]');
      var variantWrap = qs(modal, '[data-sm-fc-modal-variant-wrap]');
      var atcBtn = qs(modal, '[data-sm-fc-modal-atc]');
      var pdpEl = qs(modal, '[data-sm-fc-modal-pdp]');
      var images = (product.images && product.images.length ? product.images : [product.image]).map(absUrl).filter(Boolean);

      renderThumbs(imageEl, thumbsEl, images);
      if (vendorElM) vendorElM.textContent = product.vendor || '';
      if (titleEl) titleEl.textContent = product.title || '';
      if (priceEl) priceEl.innerHTML = formatPrice(product);
      if (modalStarsEl) {
        var rating = reviewRating(product);
        var count = reviewCount(product);
        modalStarsEl.hidden = false;
        modalStarsEl.innerHTML = starsHtml(rating) +
          '<span class="sm-fc-card__count">' +
            (rating ? rating.toFixed(1) + ' · ' : '') +
            formatCount(count) + (count === 1 ? ' review' : ' reviews') +
          '</span>';
      }
      if (modalDescEl) modalDescEl.innerHTML = '<p class="sm-fc-modal__reviews-load">Loading details…</p>';
      if (pdpEl) pdpEl.href = '/products/' + encodeURIComponent(product.handle);
      if (variantEl) {
        var variants = product.variants || [];
        if (variants.length > 1) {
          variantEl.hidden = false;
          if (variantWrap) variantWrap.hidden = false;
          variantEl.innerHTML = variants.map(function (variant) {
            return '<option value="' + escapeHtml(String(variant.id)) + '"' + (variant.available ? '' : ' disabled') + '>' +
              escapeHtml(variant.title) + (variant.available ? '' : ' — sold out') + '</option>';
          }).join('');
          var first = firstAvailableVariant(product);
          if (first) variantEl.value = String(first.id);
        } else {
          variantEl.hidden = true;
          if (variantWrap) variantWrap.hidden = true;
          variantEl.innerHTML = '';
        }
      }
      if (atcBtn) {
        atcBtn.disabled = !product.available;
        atcBtn.dataset.variantId = String((firstAvailableVariant(product) || {}).id || '');
        atcBtn.textContent = product.available ? 'Add to cart' : 'Sold out';
      }

      setModalReviewsHtml('<p class="sm-fc-modal__reviews-load">Loading reviews…</p>');
      setModalView(reviewCount(product) ? 'reviews' : 'details');
      modal.hidden = false;
      document.documentElement.classList.add('sm-fc-modal-open');
      loadReviewPage(1, false);

      fetch('/products/' + encodeURIComponent(product.handle) + '?view=showroom-json', { credentials: 'same-origin' })
        .then(function (res) { return res.text(); })
        .then(function (text) {
          var payload = {};
          try { payload = JSON.parse(text); } catch (err) { payload = {}; }
          if (modalDescEl) {
            var cleaned = cleanDescription(payload.description || '');
            modalDescEl.innerHTML = cleaned || '<p>No description available.</p>';
          }
          if (payload.images && payload.images.length && thumbsEl && imageEl) {
            var extra = payload.images.map(absUrl).filter(Boolean);
            if (extra.length) renderThumbs(imageEl, thumbsEl, extra);
          }
        })
        .catch(function () {
          if (modalDescEl) modalDescEl.innerHTML = '<p>No description available.</p>';
        });
    }

    function closeModal() {
      if (!modal) return;
      modal.hidden = true;
      document.documentElement.classList.remove('sm-fc-modal-open');
      modalProduct = null;
      reviewsRequestId += 1;
      reviewsLoading = false;
    }

    shop.addEventListener('click', function (event) {
      var filterBtn = event.target.closest('[data-sm-fc-filter]');
      if (filterBtn) {
        state.category = filterBtn.getAttribute('data-value') || '';
        state.visibleCount = gridPageSize();
        renderShop();
        return;
      }

      var atcBtn = event.target.closest('[data-sm-fc-atc]');
      if (atcBtn) {
        var atcProduct = productById(atcBtn.getAttribute('data-sm-fc-atc'));
        var variant = firstAvailableVariant(atcProduct);
        addToCart(variant && variant.id, atcBtn);
        return;
      }

      var detailsBtn = event.target.closest('[data-sm-fc-details], [data-sm-fc-card]');
      if (detailsBtn) {
        var id = detailsBtn.getAttribute('data-sm-fc-details') || detailsBtn.getAttribute('data-sm-fc-card');
        openModal(productById(id));
      }
    });

    if (catSelect) {
      catSelect.addEventListener('change', function () {
        state.category = catSelect.value || '';
        state.visibleCount = gridPageSize();
        renderShop();
      });
    }

    if (moreBtn) {
      moreBtn.addEventListener('click', function () {
        state.visibleCount += gridPageSize();
        renderCards(filteredProducts(), true);
      });
    }

    if (modal) {
      qsa(modal, '[data-sm-fc-modal-close]').forEach(function (btn) {
        btn.addEventListener('click', closeModal);
      });
      modal.addEventListener('click', function (event) {
        var viewBtn = event.target.closest('[data-sm-fc-modal-view]');
        if (viewBtn) {
          setModalView(viewBtn.getAttribute('data-sm-fc-modal-view'));
          return;
        }
        var moreReviews = event.target.closest('[data-sm-fc-reviews-more]');
        if (moreReviews) {
          loadReviewPage(reviewsPage + 1, true);
          return;
        }
        var thumb = event.target.closest('.sm-fc-modal__thumb');
        if (thumb) {
          var imageEl = qs(modal, '[data-sm-fc-modal-image]');
          if (imageEl) imageEl.src = absUrl(thumb.getAttribute('data-src'));
          qsa(modal, '.sm-fc-modal__thumb').forEach(function (node) {
            node.classList.toggle('is-active', node === thumb);
          });
          return;
        }
        var modalAtc = event.target.closest('[data-sm-fc-modal-atc]');
        if (modalAtc) addToCart(modalAtc.dataset.variantId, modalAtc);
      });
      var variantEl = qs(modal, '[data-sm-fc-modal-variant]');
      if (variantEl) {
        variantEl.addEventListener('change', function () {
          var atcBtn = qs(modal, '[data-sm-fc-modal-atc]');
          if (atcBtn) atcBtn.dataset.variantId = variantEl.value;
        });
      }
      document.addEventListener('keydown', function (event) {
        if (!modal.hidden && event.key === 'Escape') closeModal();
      });
    }

    function ingest(batch) {
      products = products.concat(batch || []);
      var seen = {};
      products = products.filter(function (product) {
        var id = String(product.id);
        if (seen[id]) return false;
        seen[id] = true;
        return true;
      });
      renderShop();
    }

    function loadCatalog() {
      var handle = config.collectionHandle;
      if (!handle) {
        setLoad('');
        if (emptyEl) {
          emptyEl.hidden = false;
          emptyEl.textContent = 'Assign a collection on this page’s Shop Collection metafield to load the mod list.';
        }
        return;
      }

      var pageSize = config.pageSize || 250;
      var knownCount = Number(config.productsCount) || 0;
      var pages = Math.max(1, Math.ceil((knownCount || pageSize) / pageSize));
      var loaded = 0;
      setLoad('Loading the build…');

      function fetchPage(page, attempt) {
        attempt = Number(attempt) || 1;
        return fetch('/collections/' + encodeURIComponent(handle) + '?view=showroom-json&page=' + page, {
          credentials: 'same-origin'
        })
          .then(function (res) {
            if (!res.ok) throw new Error('Featured car catalog failed');
            return res.text();
          })
          .then(function (text) {
            var batch = [];
            try { batch = JSON.parse(text); } catch (err) { batch = []; }
            if (!Array.isArray(batch)) batch = [];
            loaded += 1;
            ingest(batch);
            setLoad('Loading the build… ' + Math.min(100, Math.round((loaded / pages) * 100)) + '%');
            return batch;
          })
          .catch(function () {
            if (attempt < 4) {
              return new Promise(function (resolve) {
                window.setTimeout(function () {
                  resolve(fetchPage(page, attempt + 1));
                }, 400 * attempt);
              });
            }
            return [];
          });
      }

      var jobs = [];
      var i;
      for (i = 1; i <= pages; i += 1) jobs.push(fetchPage(i));
      Promise.all(jobs).then(function () {
        setLoad('');
        if (!products.length && emptyEl) {
          emptyEl.hidden = false;
          emptyEl.textContent = 'No products in this collection yet.';
        }
      });
    }

    loadCatalog();
  }

  function boot() {
    qsa(document, ROOT_SEL).forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target && event.target.querySelector
      ? event.target.querySelector(ROOT_SEL)
      : null;
    if (root) {
      root.dataset.smFcReady = '';
      initRoot(root);
    }
  });
})();
